module.exports = __webpack_public_path__ + "images/emoji/mens.3e3ca3cfe8699b2c6b6b.png";